import React, { useRef } from "react"

import { Wrapper, List, Item, ItemText, ItemSeparator } from "./styles"

const Subnavigation = ({ article, element }) => {
  const { template } = article
  const isFeatured = template === "feature"

  const ref = useRef(null)

  return (
    <Wrapper isFeatured={isFeatured}>
      <List ref={ref}>
        {element.links.map((link, idx) => (
          <Item key={link.text} href={`#mbg-${link.anchor}`}>
            <ItemText>{link.text}</ItemText>
            {idx !== element.links.length - 1 && <ItemSeparator />}
          </Item>
        ))}
      </List>
    </Wrapper>
  )
}

export default Subnavigation
